














import { DeviceEnum } from '../../enums';

export default {
  name: 'login-input',
  data: function () {
    return {
      DeviceEnum
    };
  },
  methods: {
    onInputChange: function () {
      const inputEl: HTMLInputElement = (this.$refs.input as HTMLInputElement);
      this.$emit('input', inputEl.value);
    }
  },
  props: {
    type: {
      type: String,
      default: 'text'
    },
    value: String,
    name: String,
    icon: String
  }
};

